import type { Notification, NotificationGroupedByDate } from '@/modules/Customer/interface/Notification';
import type { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Flex, Text } from '@eqi-investimentos/react';
import { appConfig } from '@/config/app';
import { formatDateToPTBRDayMonth } from '@/utils/date';
import { MapRender } from '@/utils/jsx';
export const NotificationView: FC<NotificationViewProps> = ({
  notifications
}) => {
  if (!notifications || Object.keys(notifications).length === 0) {
    return <></>;
  }
  return <Flex direction="column" gap="3xl" data-sentry-element="Flex" data-sentry-component="NotificationView" data-sentry-source-file="NotificationView.tsx">
      <MapRender items={Object.keys(notifications) as (keyof NotificationGroupedByDate)[]} render={key => <Flex key={key} direction="column" gap="l">
            <Text size="2xl" textTransform="capitalize" color="content.primary">
              {key.toLocaleLowerCase()}
            </Text>
            <Flex flexDir="column" gap="xl">
              <MapRender items={notifications[key]} render={notification => <Flex key={notification.title} as={Link} href={mountPathToLink(notification)} justifyContent="center" alignItems="center" p="s" pb="2.25rem" gap="m" w="full" borderBottomWidth="1px" borderColor="border.secondary">
                    <Flex direction="column" gap="s">
                      <Text size="l" color="content.brand">
                        {notification.title}
                      </Text>
                      <Text size="l" color="content.secondary" noOfLines={2}>
                        {notification.description}
                      </Text>
                      <Text size="m" color="content.tertiary">
                        {formatDateToPTBRDayMonth(new Date(notification.send_after)).replace(' ', ' de ')}
                      </Text>
                    </Flex>
                    <Flex position="relative" minW="5.5rem" h="3.25rem" flex={1}>
                      <Image src={getThumbNotification(notification?.thumb)} alt={notification?.title} fill style={{
              objectFit: 'cover',
              borderRadius: '0.25rem'
            }} />
                    </Flex>
                  </Flex>} />
            </Flex>
          </Flex>} data-sentry-element="MapRender" data-sentry-source-file="NotificationView.tsx" />
    </Flex>;
};
const contentTypeByURLType = {
  content: 'conteudo',
  contents: 'conteudo',
  default: 'conteudo',
  interview: 'conteudo',
  movie: 'conteudo',
  video: 'conteudo',
  event: 'eventos',
  events: 'eventos',
  course: 'programa',
  journey: 'programa',
  podcast: 'programa',
  program: 'programa',
  programs: 'programa',
  recommendation: 'programa',
  series: 'programa',
  tutorial: 'programa',
  analyst: 'autor',
  author: 'autor',
  autor: 'autor',
  journeyhome: 'jornadas',
  coursehome: 'cursos',
  entertainmenthome: 'filmes',
  research: 'research',
  investing: 'investir',
  news: 'noticias',
  newshome: 'noticias',
  recommended: 'ativos-recomendados',
  profile: 'meu-perfil',
  user: 'meu-usuario',
  historicuserciew: 'meu-historico',
  historicuserview: 'meu-historico',
  lives: 'ao-vivo',
  wallet: 'minha-carteira',
  businesscredit: 'credito-empresarial',
  exchange: 'cambio',
  freeenegymarket: 'mercado-livre-energia',
  homeequity: 'home-equity',
  lifeinsurance: 'seguro-vida',
  realstatefinancing: 'financiamento-imobiliario',
  consortium: 'consorcio',
  pension: 'previdencia',
  creditcard: 'cartao-de-credito'
} as const;
const mountPathToLink = (data?: Partial<Notification>) => {
  const typeContent = contentTypeByURLType[data?.url_type as ContentTypeByURLType] || contentTypeByURLType.default;
  if (!data?.id && !data?.slug) {
    return '#';
  }
  if (typeContent === 'eventos') {
    return `/eventos`;
  }
  if (data?.slug?.includes(appConfig.scheme)) {
    return data.slug.split(appConfig.scheme)[1];
  }
  const urlRedirect = (data?.slug || data?.id) ?? '';
  return `/${typeContent}/${urlRedirect}`;
};
type NotificationViewProps = {
  notifications: NotificationGroupedByDate;
};
type ContentTypeByURLType = keyof typeof contentTypeByURLType;
const getThumbNotification = (thumb: string) => {
  if (!thumb) return '/assets/placeholder_assets.png';
  return thumb.startsWith('http') ? thumb : '/assets/placeholder_assets.png';
};